import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { apiCall_domain, apiCall_domainV2 } from "../api";

const colors = [
  "#fffbe6",
  "linear-gradient(90deg, rgba(42,212,187,1) 14%, rgba(213,0,192,1) 100%)",
];

const FortuneWheel = ({ giftsList, spin, handleSetDeg, setCustomState }) => {
  const [rotation, setRotation] = useState(0);
  const [apiData, setApiData] = useState(null);
  const [start, setStart] = useState(false);
  const rotationRef = useRef(rotation);
  const speedRef = useRef(100);
  const intervalRef = useRef(null); // <-- Use ref to persist interval

  // Fetch API data when spin becomes true
  useEffect(() => {
    if (spin) {
      setStart(true);
      const fetchApiData = async () => {
        try {
          const res = await axios.get(
            `${apiCall_domainV2}/customer/market/indexSpin`
          );
          setApiData(res.data);
        } catch (err) {
          setCustomState((prevState) => ({
            ...prevState,
            spin: false,
            wheelEnlarged: false,
            showInfo: true,
          }));
          rotationRef.current = 0;

          setApiData({});
        }
      };

      fetchApiData();
    }
  }, [spin]);

  // Spinning logic (runs until we get API data)
  useEffect(() => {
    if (start && !apiData) {
      speedRef.current = 100; // Reset speed at the start

      intervalRef.current = setInterval(() => {
        rotationRef.current += speedRef.current;
        setRotation(rotationRef.current); // Update rotation
        speedRef.current = Math.max(10, speedRef.current - 5); // Slow down over time
      }, 25);
    }

    return () => {
      if (intervalRef.current) {
        setStart(false);
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [start, apiData]); // Dependencies: start, apiData

  // Update ref with latest rotation
  useEffect(() => {
    rotationRef.current = rotation;
  }, [rotation]);

  // Handle spinning logic when apiData is updated
  useEffect(() => {
    if (apiData) {
      const { is_winner: isWinner, gift = {} } = apiData;
      const winItem = gift.title;

      setCustomState({
        spin: false,
        wheelEnlarged: false,
        showInfo: false,
        showAward: true,
        isWinner,
        winIndex: giftsList.findIndex((w) => w.title === gift.title),
        award_code: gift.code,
        award: gift.title,
      });

      const winItemIndex = giftsList.findIndex((g) => g.title === winItem);
      const segmentAngle = 360 / giftsList.length;

      // Determine how many full rotations you want before landing
      const fullRotations = 5; // Number of full spins before stopping

      // Calculate the angle to align the winning segment at the top (0 degrees)
      const targetRotation = segmentAngle * winItemIndex;

      // Final rotation includes full rotations and aligns the winning segment
      const finalRotation =
        fullRotations * 360 + (360 - targetRotation) + segmentAngle / 2;

      // Set the rotation reference
      rotationRef.current = finalRotation;
      // Clear the interval and reset
      clearInterval(intervalRef.current);
      intervalRef.current = null;

      // Reset the API data
      setApiData(null);
    }
  }, [apiData, giftsList, setCustomState, handleSetDeg]);
  useEffect(() => {
    setRotation(rotationRef.current);
  }, [rotationRef, rotationRef.current]);

  return (
    <div className="wheelWrapper">
      <div className="wheelContainer">
        <div className="spinBtn"></div>
        <div className="indicator"></div>
        <div
          className="wheel"
          style={{
            transform: `rotate(${rotation}deg)`,
            // direction: "ltr",
            rotate: `${360 / giftsList.length}deg`,
          }}
        >
          {giftsList.map((gift, index) => {
            const backgroundColor = colors[index % colors.length];
            const angle = (360 / giftsList.length) * index;

            // Calculate clip-path values dynamically based on list length
            const basePercentage = 360 / giftsList.length; // This is your 45% value for when there are 12 items
            const dynamicPercentage = basePercentage / 2 + basePercentage;

            // Create the clip-path using the dynamic percentage
            const clipPath = `polygon(0 0, ${dynamicPercentage}% 0, 100% 100%, 0 ${dynamicPercentage}%)`;

            const giftStyle = {
              transform: `rotate(${angle}deg)`,
              background: backgroundColor,
              color: backgroundColor === "#fffbe6" ? "black" : "white",
              clipPath: clipPath, // Apply the dynamic clip-path
            };
            return (
              <div key={gift.id} style={giftStyle} className="giftItem">
                <div className="item">
                  <span className="giftTitle">{gift.title}</span>
                  <img src={gift.image} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FortuneWheel;
